module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section06_02_american-village-07630b51773c96f6cae3d1ef1a32e288.jpg";